module.exports = __webpack_public_path__ + "img/products-3@2x.da5b41d.webp";